import { TextField, NumberFormat, DobField } from "vino/core";

const Contact = () => {
	return (
		<>
			<div className="mb-16 w-full">
				<TextField
					name="address.firstName"
					label="First Name"
					required
					fullWidth
				/>
			</div>
			<div className="mb-16 w-full">
				<TextField
					name="address.lastName"
					label="Last Name"
					required
					fullWidth
				/>
			</div>

			<div className="mb-16 w-full">
				<DobField
					name="address.dateOfBirth"
					label="Date of birth"
					required
					fullWidth
				/>
			</div>

			<div className="mb-16 w-full">
				<TextField
					name="address.phone"
					label="Phone"
					required
					fullWidth
					inputProps={{
						format: "(###) ###-####",
					}}
					InputProps={{
						inputComponent: NumberFormat,
					}}
				/>
			</div>
		</>
	);
};

export default Contact;
